module.exports = __webpack_public_path__ + "img/4_97.76eafb1d.png";